// export const API_URL = 'https://dr.stm-labs.ru';
export const API_URL = "";
